const Reward = () => (
  <svg
    width='23'
    viewBox='0 0 23 30'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M5.5 30V16H17.5V30L11.5 25.6923L5.5 30Z' fill='#88122B' />
    <g filter='url(#filter0_d)'>
      <circle cx='11.5' cy='10' r='10' fill='url(#paint0_linear)' />
    </g>
    <path
      d='M11.0516 4.90849C11.235 4.53687 11.765 4.53687 11.9484 4.90849L13.147 7.33723C13.2199 7.4848 13.3606 7.58708 13.5235 7.61075L16.2038 8.00021C16.6139 8.05981 16.7776 8.56379 16.4809 8.85306L14.5414 10.7436C14.4236 10.8584 14.3698 11.0239 14.3976 11.1861L14.8554 13.8556C14.9255 14.264 14.4968 14.5755 14.13 14.3827L11.7327 13.1223C11.587 13.0457 11.413 13.0457 11.2673 13.1223L8.87003 14.3827C8.50321 14.5755 8.07449 14.264 8.14455 13.8556L8.60239 11.1861C8.63021 11.0239 8.57644 10.8584 8.4586 10.7436L6.51914 8.85306C6.22238 8.56379 6.38613 8.05981 6.79624 8.00021L9.47651 7.61075C9.63937 7.58708 9.78015 7.4848 9.85298 7.33723L11.0516 4.90849Z'
      fill='#F5F6FB'
    />
    <circle cx='11.5' cy='10' r='7.75' stroke='#88122B' strokeWidth='0.5' />
    <defs>
      <filter
        id='filter0_d'
        x='0.5'
        y='0'
        width='22'
        height='22'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='1' />
        <feGaussianBlur stdDeviation='0.5' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear'
        x1='5.13636'
        y1='3.63636'
        x2='19.2273'
        y2='16.8182'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B82F4C' />
        <stop offset='0.479167' stopColor='#88122B' />
        <stop offset='1' stopColor='#B72E4B' />
      </linearGradient>
    </defs>
  </svg>
)

export default Reward
